<template>
    <div>
        <div class="e-title">基础信息</div>
        <el-descriptions style="margin-bottom: 20px" :column="2">
            <el-descriptions-item label="头像">
                <img style="width: 60px; height: 60px; border-radius: 30px" :src="ossUrl + form.avatar" alt="" />
            </el-descriptions-item>
            <el-descriptions-item label="性别">{{ { 1: "男", 2: "女" }[form.sex] }}</el-descriptions-item>
            <el-descriptions-item label="姓名">{{ form.nick_name }}</el-descriptions-item>
            <el-descriptions-item label="出生日期">{{ form.birth }}</el-descriptions-item>
            <el-descriptions-item label="ID">{{ form.uuid }}</el-descriptions-item>
            <el-descriptions-item label="职业">{{ form.job }}</el-descriptions-item>
            <el-descriptions-item label="手机">{{ form.mobile || "/" }}</el-descriptions-item>
            <el-descriptions-item label="城市">{{ address }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ form.email || "/" }}</el-descriptions-item>
            <el-descriptions-item label="兴趣">{{ form.interest }}</el-descriptions-item>
            <el-descriptions-item label="关联标签">
                <div style="display: flex; flex-wrap: wrap; gap: 5px">
                    <el-tag size="small" v-for="(item, index) in form.label" :key="index">{{ item.name }}</el-tag>
                </div>
            </el-descriptions-item>
            <el-descriptions-item label="收货地址">{{ form.address_detail }}</el-descriptions-item>
        </el-descriptions>
        <div class="e-title">推广绑定数据</div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            :search="false"
        >
            <template slot="columns">
                <el-table-column label="ID" align="center" prop="uuid" show-overflow-tooltip />
                <el-table-column label="用户名称" align="center" prop="nick_name" />
                <el-table-column label="注册手机号" align="center" prop="mobile" />
                <el-table-column label="注册邮箱号" align="center" prop="email" />
                <el-table-column label="拉新时间" align="center" prop="create_time" />
            </template>
        </ListPage>
        <el-button type="primary" style="width: 120px" @click="$router.back()">返回</el-button>
    </div>
</template>

<script>
import { detail, list } from "@/api/member/list";
import listMixin from "@/mixins/list";
import { ossUrl } from "@/configs/oss";
export default {
    data() {
        return {
            ossUrl,
            form: {},
            // 查询参数
            query: {
                search_fid_uuid: "",
            },
        };
    },
    mixins: [listMixin],
    computed: {
        address() {
            const country = this.form.mcountry ? this.form.mcountry.zh_name : "";
            const province = this.form.mprovince ? this.form.mprovince.zh_name : "";
            const city = this.form.mcity ? this.form.mcity.zh_name : "";
            return `${country} ${province} ${city}`;
        },
    },
    created() {
        const uuid = this.$route.query.uuid;
        this.query.search_fid_uuid = uuid;
        this.search();
        if (uuid) {
            this.getDetail(uuid);
        }
    },
    methods: {
        getDetail(uuid) {
            detail({ uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result || {};
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            list(params).then(({ code, result, msg }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                } else {
                    this.$message.error(msg);
                }
                this.loading = false;
            });
        },
    },
};
</script>

<style></style>
